import { inject, Pipe, PipeTransform } from '@angular/core';
import { EntityAction, HeatMap } from '@wdx/clmi/clmi-swagger-gen';
import {
    FeaturesService,
    NavItem,
    TranslationsService,
} from '@wdx/shared/utils';
import { ICON_CONTEXT_MENU } from '../constants/icons.constants';

@Pipe({ name: 'heatMapToMenuItems', standalone: false })
export class HeatMapToMenuItemsPipe implements PipeTransform {
    private translationsService = inject(TranslationsService);

    transform(
        heatMap: HeatMap,
        staticItems?: NavItem[],
        staticMoreActionItems?: NavItem[],
        moreActions?: EntityAction[],
        rootActions?: EntityAction[],
    ): NavItem[] {
        if (!heatMap) {
            return [];
        }

        const moreActionsItems: NavItem[] =
            this.convertActionsToNavItems(moreActions);
        const rootActionsItems: NavItem[] =
            this.convertActionsToNavItems(rootActions);

        const moreActionsItem: NavItem = (staticMoreActionItems?.length ||
            moreActionsItems?.length) && {
            label: this.translationsService.getTranslationByKey(
                'MORE_ACTIONS_MENU_LABEL',
            ),
            value: 'moreActions',
            cySelector: 'menu-item-More Actions',
            icon: ICON_CONTEXT_MENU.icon,
            linkedMenu: [
                ...(staticMoreActionItems || []),
                ...(moreActionsItems || []),
            ],
        };

        return [
            ...(staticItems || []),
            ...(rootActionsItems || []),
            ...(moreActionsItem ? [moreActionsItem] : []),
        ];
    }

    private convertActionsToNavItems(actions?: EntityAction[]): NavItem[] {
        return (
            actions?.map((action) => {
                const actionTranslation = this.getValidTranslation(
                    action.displayName.key,
                );
                const linkedMenu = action.children?.length
                    ? {
                          linkedMenu: action.children.map((item) => {
                              const itemTranslation = this.getValidTranslation(
                                  item.displayName.key,
                              );

                              return {
                                  label:
                                      item.displayName.value ??
                                      itemTranslation,
                                  translationKey: itemTranslation
                                      ? item.displayName.key
                                      : null,
                                  icon: item.icon,
                                  data: {
                                      formName: item.formName,
                                      url: item.url,
                                      type: item.type,
                                  },
                              };
                          }),
                      }
                    : {};
                return {
                    label:
                        action.displayName.value ?? actionTranslation,
                    translationKey: actionTranslation
                        ? action.displayName.key
                        : null,
                    icon: action.icon,
                    data: {
                        formName: action.formName,
                        url: action.url,
                        type: action.type,
                    },
                    ...linkedMenu,
                };
            }) || []
        );
    }

    private getValidTranslation(key?: string): string | null {
        if (!key) {
            return null;
        }

        const translation = this.translationsService.getTranslationByKey(key);
        return translation && translation !== key ? translation : null;
    }
}
